export enum ReferralType {
  default = 'default', // likely not used anymore
  healix = 'healix',
  landg = 'landg',
  generic = 'generic', // should supersede custom organizations
}
